export const galleryItems = [
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061619/salvation/_DSC4165_bic0dt.jpg",
    title: "Harvest 2021",
  },
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061613/salvation/_DSC4215_ocngfe.jpg",
    title: " Harvest 2021",
  },
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061612/salvation/_DSC3940_o4pjar.jpg",
    title: "Harvest 2021",
  },
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061617/salvation/_DSC3816_r5lfko.jpg",
    title: " Harvest 2021",
  },
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061609/salvation/_DSC4120_ibyguz.jpg",
    title: "Harvest 2021",
  },
  {
    link: "https://res.cloudinary.com/dsywsrg4f/image/upload/v1665061615/salvation/_DSC3817_f0koji.jpg",
    title: " Harvest 2021",
  },
];
